import { render, staticRenderFns } from "./ViewPurchasesDeliveryComponent.vue?vue&type=template&id=775e31d1"
import script from "./ViewPurchasesDeliveryComponent.vue?vue&type=script&lang=js"
export * from "./ViewPurchasesDeliveryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports